'use client'
import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import type { Range } from 'react-date-range'

const DateRangePicker = dynamic(
  () =>
    import('react-date-range').then(
      (module) => module.DateRangePicker as React.ComponentType<any>,
    ),
  { ssr: false },
)

const EarningCalendar = ({
  defaultRange,
}: {
  defaultRange: { startDate: Date; endDate: Date }
}) => {
  const selectionRange: Range = {
    startDate: defaultRange.startDate,
    endDate: defaultRange.endDate,
    key: 'selection',
  }

  useEffect(() => {
    const days = document.querySelectorAll('.rdrDay')

    days.forEach((day) => {
      const dateElement = day.querySelector('.rdrDayNumber span')
      if (dateElement && dateElement.textContent === '7') {
        const dayElement = day as HTMLElement
        dayElement.style.backgroundColor = '#24BFA350'
        dayElement.style.color = 'white'
        dayElement.style.borderRadius = '12px'
      }
    })
  }, [])

  return (
    <>
      <style>{`
        .rdrMonthAndYearWrapper, .rdrDefinedRangesWrapper, .rdrDateDisplayWrapper {
          display: none !important; 
        }
        .rdrMonthName {
          color: #3E3E3E;
          font-size: 16px;
          display: flex;
          justify-content: center;
          padding: 8px 20px 8px;
        }
        .rdrCalendarWrapper, .rdrDateRangeWrapper, .rdrDateRangePickerWrapper{
          display: flex !important;
          justify-content: center !important;
          border-radius: 1.5rem !important;
          width: 100% !important;
          }
        .rdrCalendarWrapper{
          padding: 10px;
        }
        .rdrStartEdge, .rdrEndEdge {
         background-color: #24BFA3 !important; 
         right: 0px; 
         }
         .rdrEndEdge {
          border-top-right-radius: 8px; 
          border-bottom-right-radius: 8px; 
         }
         .rdrStartEdge {
           border-top-left-radius: 8px; 
         border-bottom-left-radius: 8px; 
         }
     .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span, .rdrStartEdge ~ .rdrDayNumber span{
      color: white !important;
     }
        .rdrMonth:first-of-type {
         border-right: 2px solid #65656550;
        }
        .rdrDayToday .rdrDayNumber span:after {
         background: transparent !important; 
        }
        .rdrDay:hover {
         background-color: transparent !important;
         color: #656565 !important; 
          cursor: not-allowed;
        }
        .rdrDayNumber span {
         color: #656565 !important; 
         font-weight: 500;
        }
        .rdrDayToday {
         text-decoration: none !important; 
         color: #656565 !important; 
        }
        .rdrInRange {
         background-color: #318FD233 !important;
         }
      `}</style>

{/* @ts-ignore */}
      <DateRangePicker
        editableDateInputs={false}
        moveRangeOnFirstSelection={false}
        showMonthAndYearPickers={false}
        showMonthArrow={false}
        showPreview={false}
        dragSelectionEnabled={false}
        ranges={[selectionRange]}
        className="!important cursor-not-allowed rounded-3xl"
        onChange={() => false}
        months={2}
        direction="horizontal"
        weekdayDisplayFormat="ccccc"
      />
    </>
  )
}

export default EarningCalendar
